import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@ncdai/react-wheel-picker/style.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { SkeletonTheme } from "react-loading-skeleton";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LoadScript } from "@react-google-maps/api";
import AnimatedLoader from "./components/AnimatedLoader";

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Google Maps API key
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

// Define libraries as a constant to avoid re-renders
const libraries = ["marker", "places", "geometry"];

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LoadScript
        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
        libraries={libraries}
        loadingElement={<AnimatedLoader />}
      >
        <SkeletonTheme
          baseColor="rgba(75, 71, 83, 0.222)"
          highlightColor="rgba(75, 71, 83, 0.222)"
        >
          <BrowserRouter>
            <App />
            <Toaster />
          </BrowserRouter>
        </SkeletonTheme>
      </LoadScript>
    </QueryClientProvider>
  </React.StrictMode>
);
